exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".zoom-svg-overlay {\n  position: absolute;\n  top: -4000px;\n  left: -4000px;\n  width: 8000px;\n  height: 8000px;\n  z-index: 9999;\n  cursor: crosshair; }\n\nsvg rect {\n  fill: #00000070;\n  stroke: #c0c0c0;\n  stroke-width: 1px; }\n", "", {"version":3,"sources":["/home/alan/workspace/ceabs/portal/front-end/external-components/ZoomTool-GoogleMaps-V3/src/styles.scss"],"names":[],"mappings":"AAAA;EACC,mBAAkB;EAClB,aAAY;EACZ,cAAa;EACb,cAAa;EACb,eAAc;EACd,cAAa;EACb,kBAAiB,EACjB;;AAED;EACC,gBAAe;EACf,gBAAe;EACf,kBAAiB,EACjB","file":"styles.scss","sourcesContent":[".zoom-svg-overlay {\n\tposition: absolute;\n\ttop: -4000px;\n\tleft: -4000px;\n\twidth: 8000px;\n\theight: 8000px;\n\tz-index: 9999;\n\tcursor: crosshair;\n}\n\nsvg rect {\n\tfill: #00000070;\n\tstroke: #c0c0c0;\n\tstroke-width: 1px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":true}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./src/styles.scss
// module id = 18
// module chunks = 0